// DEV/TEST ONLY: when REACT_APP_BANKID_MOCK_SIGN=true (set in a gitignored
// .env.development.local, and only honoured by the backend when BankId:MockSigning
// is on and BankID is not in production), contract signing skips the BankID popup
// and uses a mock reference. With the flag unset — i.e. in production — the real
// BankID signing modal and verification run exactly as before.
// Never honoured in a production build, whatever the environment says.
import { AUTH_API_BASE_URL } from "../../config/api-config";
import { getToken } from "../../Compo/utilis/getToken";

export const BANKID_MOCK_SIGN = process.env.NODE_ENV !== "production" && process.env.REACT_APP_BANKID_MOCK_SIGN === "true";

export const mockSignRef = (role, contractId) => `mock-sign-${role}-${contractId}-${Date.now()}`;

/**
 * A mock signing reference, issued the way the real flow earns one: only after the server has fixed
 * the contract document for the CURRENT version.
 *
 * The real flow does this when a BankID order starts. Mock signing has no order, so it skipped the
 * step - which is harmless until something changes the contract just before signing (the seller's
 * debt / loan terms are saved first). That bumps the version, no document exists for the new one,
 * and the signature was recorded bound to nothing. The other party's signature then bound to the
 * document, the two never matched, and the deal could not become fully signed. Preparing here, after
 * any such change, binds the signature to the version's document exactly as a real order would.
 */
export async function mockSignRefPrepared(role, contractId) {
  const token = getToken();
  try {
    await fetch(`${AUTH_API_BASE_URL}/BankId/PrepareSigning`, {
      method: "POST",
      headers: { "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      body: JSON.stringify({ contractId, role }),
    });
  } catch (_) {
    /* the server refuses to record a signature bound to no document, and says so */
  }
  return mockSignRef(role, contractId);
}

// One clear signal in the browser console so it is obvious which mode the
// loaded bundle is in — a stale tab or a different host shows nothing here.
if (BANKID_MOCK_SIGN && typeof console !== "undefined") {
  console.info("[Klargo] BankID TEST MODE active: contract signing is mocked, no BankID app needed.");
}
